// Utility methods
const Utils = {
  defer(fn) {
    window.setTimeout(() => fn(), 0)
  }
}

export default Utils
